/* ═══════════════════════════════════════
   SWF Mobile Menu v2
   Persistent bar + full-screen takeover
   ═══════════════════════════════════════ */

class SwfMobileMenu extends HTMLElement {
  connectedCallback() {
    this.hamburger = this.querySelector('.swf-mm__hamburger');
    this.overlay = this.querySelector('.swf-mm__overlay');
    this.closeBtn = this.querySelector('.swf-mm__close');
    this.bar = this.querySelector('.swf-mm__bar');

    // Toggle bevel on scroll
    this._onScroll = () => {
      this.bar.classList.toggle('swf-mm__bar--scrolled', window.scrollY > 10);
    };
    window.addEventListener('scroll', this._onScroll, { passive: true });
    this._onScroll();

    this.hamburger.addEventListener('click', () => this.open());
    this.closeBtn.addEventListener('click', () => this.close());

    // Close on backdrop tap (screen area outside nav content)
    this.overlay.addEventListener('click', (e) => {
      if (e.target === this.overlay) this.close();
    });

    // Close on Escape
    this._onKeydown = (e) => {
      if (e.key === 'Escape' && this.classList.contains('swf-mm--open')) {
        this.close();
      }
    };
    document.addEventListener('keydown', this._onKeydown);

    // Close when any nav link, CTA, or icon is clicked
    this.querySelectorAll('.swf-mm__link, .swf-mm__cta, .swf-mm__icon').forEach((el) => {
      el.addEventListener('click', () => this.close());
    });
  }

  disconnectedCallback() {
    document.removeEventListener('keydown', this._onKeydown);
    window.removeEventListener('scroll', this._onScroll);
  }

  open() {
    this.classList.add('swf-mm--open');
    this.overlay.setAttribute('aria-hidden', 'false');
    this.hamburger.setAttribute('aria-expanded', 'true');
    document.body.classList.add('swf-menu-open');
  }

  close() {
    this.classList.remove('swf-mm--open');
    this.overlay.setAttribute('aria-hidden', 'true');
    this.hamburger.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('swf-menu-open');
  }
}

customElements.define('swf-mobile-menu', SwfMobileMenu);
